import cx from 'classnames'
import PropTypes from 'prop-types'

import MoleculeRating from '@s-ui/react-molecule-rating'
import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'
import IconStarHalf from '@adv-mt/mt-svg-icons/lib/StarHalf'
import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StartEmpty'

import {BASE_CLASS} from '../config.js'

const CardRatingCategories = ({categories}) => {
  return (
    <div className={`${BASE_CLASS}-categories`}>
      {categories.map((category, index) => (
        <div
          key={`mt-CardRating-category-${index}`}
          className={cx(`${BASE_CLASS}-category`, {
            [`${BASE_CLASS}-category--opacity30`]: !category?.rating
          })}
        >
          <span className={`${BASE_CLASS}-categoryLabel`}>{category.label}</span>
          <MoleculeRating
            IconStarEmpty={IconStarEmpty}
            IconStarFilled={IconStarFull}
            IconStarHalfFilled={IconStarHalf}
            value={category.rating}
          />
        </div>
      ))}
    </div>
  )
}

CardRatingCategories.displayName = 'CardRatingCategories'

CardRatingCategories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      rating: PropTypes.number.isRequired
    })
  ).isRequired
}

export default CardRatingCategories
